import { render } from "./InternalOrderCancerTreatmentPaths.vue?vue&type=template&id=748a6ed0&scoped=true"
import script from "./InternalOrderCancerTreatmentPaths.vue?vue&type=script&lang=js"
export * from "./InternalOrderCancerTreatmentPaths.vue?vue&type=script&lang=js"

import "./InternalOrderCancerTreatmentPaths.vue?vue&type=style&index=0&id=748a6ed0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748a6ed0"]])

export default __exports__